import { Component, ElementRef, HostListener, OnInit, QueryList, ViewChild, ViewChildren, ChangeDetectorRef } from '@angular/core';
import { FormControl, NgForm, NgModel } from '@angular/forms';
import { Signup } from 'src/app/models/SignupModels';
import { HttpClient } from '@angular/common/http';
import { AuthService } from 'src/app/services/auth.service';
import { catchError, forkJoin, of, tap } from 'rxjs';
import { SweetAlertService } from 'src/app/services/sweetalert.service';
import Swal from 'sweetalert2';
import { BreakpointObserver } from '@angular/cdk/layout';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';

@Component({
  selector: 'app-end-customer-signup',
  templateUrl: './end-customer-signup.component.html',
  styleUrls: ['./end-customer-signup.component.css']
})
export class EndCustomerSignupComponent implements OnInit {
  @ViewChildren(MatAutocompleteTrigger) autoCompletes!: QueryList<MatAutocompleteTrigger>;
  @ViewChild('countryCodeInput') countryCodeInput!: ElementRef;

  UserSignup: Signup = {} as Signup;
  emailSent: boolean = true;
  showError: boolean = false;
  errorMessage: string = '';
  isindividual: boolean = true;
  isProceed: boolean = false;
  selectedAccountType: any;
  accounttype: any[] = [];
  countrycodes: any[] = [];
  badRequest: boolean = false;
  selectedPhoneCode: string = '';
  isSignupButtonEnabled: boolean = false;
  countryCode: string | undefined;
  filter: any;
  isSelected: boolean = false;
  refEmail: string = 'info@digiworldexpo.com';
  accounttypevalues: string[] = ['Individual', 'Organisation'];
  email: string = '';
  emailInvalid: boolean = false;
  validNumber: boolean = true;
  usertype = 'Organization,Individual';
  showPassword: boolean = false;
  showConfirmPassword: boolean = false;
  accountTypeName: any = '';
  filteredAccountTypes: any[] = [];
  accountTypeControl = new FormControl('', [(control) => (control.value ? null : { required: true })]);
  selectedAccountCategory: string = '';
  individualAccounts: any[] = [];
  organizationAccounts: any[] = [];

  fields = [
    { key: 'countryCode', label: 'Country Code' },
    { key: 'accountType', label: 'Account Type' },
    { key: 'organization', label: 'Organization' },
    { key: 'salutation', label: 'Salutation' },
    { key: 'firstName', label: 'First Name' },
    { key: 'lastName', label: 'Last Name' },
    { key: 'email', label: 'Email' },
    { key: 'password', label: 'Password' },
    { key: 'confirmPassword', label: 'Confirm Password' },
    { key: 'website', label: 'Website' },
    { key: 'phoneNumber', label: 'Phone Number' },
    { key: 'companyName', label: 'Company Name' },
    { key: 'role', label: 'Role' },
    { key: 'phoneCode', label: 'Phone Code' }
  ];

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private sweetAlertService: SweetAlertService,
    private breakpointObserver: BreakpointObserver,
    private cdr: ChangeDetectorRef
  ) {
    this.UserSignup = { role: 'USER' } as Signup;
    window.addEventListener('scroll', this.scrollEvent, true);
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    if (this.countryCodeInput && !this.countryCodeInput.nativeElement.contains(event.target)) {
      this.showOptions = false;
    }
  }
  ngOnInit() {
    const topOfPage = document.querySelector('app-website-header');
    if(topOfPage) {
      topOfPage.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
    this.checkAllBreakPoints();
    this.fetchDropdownData();
    this.filteredAccountTypes = [];
  }

  validateAccountTypeOnBlur() {
    const value = this.accountTypeControl.value;
    const selectedAccount = this.accounttype.find(account => account.name === value);
    if (!selectedAccount) {
      this.accountTypeControl.setErrors({ required: true });
      this.UserSignup.accountType = ''; // Clear invalid value
      this.accountTypeName = '';
    } else {
      this.accountTypeControl.setErrors(null);
      this.UserSignup.accountType = selectedAccount.id;
      this.accountTypeName = selectedAccount.name;
    }
    this.accountTypeControl.markAsTouched();
  }

  validateCountryCodeOnBlur() {
    const value = this.UserSignup.countryCode?.trim();
    const validCountryCode = this.countrycodes.find(code => code.countryCode.toLowerCase() === value?.toLowerCase());
    if (!value || !validCountryCode) {
      this.UserSignup.countryCode = '';
      this.UserSignup.phoneCode = '';
    } else {
      this.UserSignup.countryCode = validCountryCode.countryCode;
      this.UserSignup.phoneCode = validCountryCode.phoneCode;
    }
    this.countryCodeInput.nativeElement.form.control.get('countryCode')?.markAsTouched();
    this.cdr.detectChanges();
  }

  checkAllBreakPoints() {
    this.breakpointObserver.observe(['(max-width: 767.98px)']).subscribe(r => {
      if (r.matches) {
        if (r.breakpoints['(max-width: 767.98px)']) {
          this.resetScrollSettings();
        }
      }
    });
  }

  resetScrollSettings(): void {
    setTimeout(() => {
      const body = document.body;
      const html = document.documentElement;
      body.style.overflow = 'auto';
      html.style.overflow = 'auto';
    });
  }
  preventCopyPaste(event: Event): void {
    event.preventDefault();
  }

  preventContextMenu(event: MouseEvent): void {
    event.preventDefault();
  }

  numberOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    return !(charCode > 31 && (charCode < 48 || charCode > 57));
  }

  onlyText(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (
      (charCode >= 48 && charCode <= 57) ||
      (charCode >= 65 && charCode <= 90) ||
      (charCode >= 97 && charCode <= 122) ||
      charCode === 32
    ) {
      return true;
    }
    return false;
  }
  onlyText3(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (
      (charCode >= 48 && charCode <= 57) ||
      (charCode >= 65 && charCode <= 90) ||
      (charCode >= 97 && charCode <= 122)
    ) {
      return true;
    }
    return false;
  }

  onlyText2(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if ((charCode >= 65 && charCode <= 90) || (charCode >= 97 && charCode <= 122)) {
      return true;
    }
    return false;
  }
  updateSelectedCountry(event: any) {
    const selectedValue = event.target?.value;
    if (selectedValue) {
      this.selectedPhoneCode = selectedValue;
      this.UserSignup.phoneCode = selectedValue;
    }
  }

  isExpanded: boolean = false;

  toggleDropdown() {
    this.isExpanded = !this.isExpanded;
  }
  submitForm(form: NgForm) {
    if (form.valid) {
      if (!this.isPasswordAndConfirmPasswordMatch(this.UserSignup.password, this.UserSignup.confirmPassword)) {
        return;
      }
      this.isProceed = false;
      this.authService.signup(this.UserSignup).subscribe({
        next: (response) => {
          this.emailSent = false;
          this.badRequest = false;
          this.errorMessage = '';
        },
        error: (error) => {
          if (error.status === 400) {
            this.badRequest = true;
            this.emailSent = true;
            this.errorMessage = error.error.message || 'Invalid data entered.';
          } else {
            this.errorMessage = error.error.message || 'An error occurred while submitting the form.';
          }
          Swal.fire('Error', this.errorMessage ? this.errorMessage : 'An error occurred while submitting the form.', 'warning');
        }
      });
    } else {
      this.showError = true;
      this.errorMessage = 'Please fill out all required fields.';
      this.isProceed = true;
      Object.values(form.controls).forEach(control => control.markAsTouched());
      this.cdr.detectChanges();
    }
  }

  fetchDropdownData() {
    forkJoin([
      this.authService.getAccounttypes(this.usertype),
      this.authService.getCountrycodes(0, 300)
    ]).subscribe(
      ([accounttypesResponse, countryCodesResponse]) => {
        this.accounttype = accounttypesResponse.data;
        this.countrycodes = countryCodesResponse.data;
        this.individualAccounts = [];
        this.organizationAccounts = [];
        this.accounttype.forEach((type: any) => {
          const accountTypeName = type.accountType?.name?.toLowerCase();
          if (accountTypeName === 'individual') {
            this.individualAccounts.push(type);
          } else if (accountTypeName === 'organization') {
            this.organizationAccounts.push(type);
          }
        });
        this.filteredAccountTypes = [];
      },
      (error) => {
        console.error('Error fetching dropdown data', error);
      }
    );
  }

  onAccountChange(event: Event) {
    const selectElement = event.target as HTMLSelectElement;
    const account = selectElement.value;
    this.selectedAccountCategory = account;
    this.UserSignup.accountType = '';
    this.accountTypeControl.setValue('');
    this.accountTypeName = '';
    this.isSelected = false;
    if (account === 'Individual') {
      this.filteredAccountTypes = this.individualAccounts;
      this.isindividual = true;
    } else if (account === 'Organisation') {
      this.filteredAccountTypes = this.organizationAccounts;
      this.isindividual = false;
    } else {
      this.filteredAccountTypes = [];
      this.isindividual = true;
    }
    this.closeAllPanels();
    this.updateFirstNamePrefix();
    this.accountTypeControl.setErrors(null);
  }

  fetchAccountTypes() {
    this.authService.getAccounttypes(this.usertype).subscribe(
      (response: any) => {
        this.accounttype = response.data;
        this.filteredAccountTypes = this.accounttype;
      },
      (error) => {}
    );
  }

  filterAccountTypes(event: any) {
    const searchValue = event.target.value?.toLowerCase() || '';
    if (this.selectedAccountCategory) {
      this.filteredAccountTypes = this.accounttype.filter(account =>
        account.name.toLowerCase().includes(searchValue) &&
        (this.selectedAccountCategory === 'Individual'
          ? account.accountType?.name?.toLowerCase() === 'individual'
          : account.accountType?.name?.toLowerCase() === 'organization')
      );
    } else {
      this.filteredAccountTypes = [];
    }
  }

  onAccountTypeSelected(event: any) {
    const selectedAccount = this.accounttype.find(account => account.id === event.option.value);
    if (selectedAccount) {
      this.accountTypeName = selectedAccount.name;
      this.UserSignup.accountType = selectedAccount.id;
      this.accountTypeControl.setValue(selectedAccount.name);
      this.isindividual = selectedAccount.accountType?.name?.toLowerCase() !== 'organization';
      this.accountTypeControl.setErrors(null);
      this.updateFirstNamePrefix();
    }
  }

  passwordValidation(password: string): string[] {
    const errors = [];
    const capitalRegex = /[A-Z]/;
    const numberRegex = /[0-9]/;
    const smallRegex = /[a-z]/;
    const specialCharRegex = /^(?!\s+)(?!.*\s+$)(?=.*[$^*.[\]{}()?"!@#%&/\\,><':;|_~`=+\- ])[A-Za-z0-9$^*.[\]{}()?"!@#%&/\\,><':;|_~`=+\- ]{8,256}$/;

    if (typeof password !== "undefined" && password != null && password.length > 0) {
      if (password.length < 8) {
        errors.push('Password must be at least 8 characters');
      } else if (!capitalRegex.test(password)) {
        errors.push('Password must contain at least one capital letter');
      } else if (!numberRegex.test(password)) {
        errors.push('Password must contain at least one number');
      } else if (!specialCharRegex.test(password)) {
        errors.push('Password must contain at least one special character');
      } else if (!smallRegex.test(password)) {
        errors.push('Password must contain at least one small letter');
      }
    }
    return errors;
  }

  updateSignupButtonState(event: Event) {
    const target = event.target as HTMLInputElement;
    this.isSignupButtonEnabled = target.checked;
  }
  showOptions: boolean = true;
  filteredCountryCodes: { phoneCode: string | undefined; countryCode: string }[] = [];

  filterOptions(inputValue: string) {
    this.showOptions = true;
    if (!inputValue) {
      this.filteredCountryCodes = this.countrycodes;
      this.UserSignup.phoneCode = '';
      this.UserSignup.countryCode = '';
      this.countryCodeInput.nativeElement.form.control.get('countryCode')?.markAsTouched();
      this.cdr.detectChanges();
      return;
    }
    const lowerInput = inputValue.toLowerCase();
    this.filteredCountryCodes = this.countrycodes.filter(code =>
      code.countryCode && code.countryCode.toLowerCase().includes(lowerInput)
    );

    const exactMatch = this.countrycodes.find(code =>
      code.countryCode && code.countryCode.toLowerCase() === lowerInput
    );
    if (exactMatch) {
      this.UserSignup.phoneCode = exactMatch.phoneCode;
      this.UserSignup.countryCode = exactMatch.countryCode;
      this.countryCodeInput.nativeElement.form.control.get('countryCode')?.setErrors(null);
    } else {
      this.UserSignup.phoneCode = '';
      this.UserSignup.countryCode = inputValue;
    }
    if (this.filteredCountryCodes.length === 0) {
      this.showOptions = false;
    }
    this.cdr.detectChanges();
  }

  selectOption(code: any) {
    this.countryCode = code.countryCode;
    this.UserSignup.phoneCode = code.phoneCode;
    this.UserSignup.countryCode = code.countryCode;
    this.showOptions = false;
    this.countryCodeInput.nativeElement.form.control.get('countryCode')?.setErrors(null);
    this.countryCodeInput.nativeElement.form.control.get('countryCode')?.markAsTouched();
    this.cdr.detectChanges();
  }
  emailValidation(email: string) {
    this.emailInvalid = true;
    this.emailInvalid = !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);
  }
  phonenumbervalidation(phoneNumber: any) {
    this.validNumber = /^[0-9]+$/.test(phoneNumber) && phoneNumber.length >= 5 && phoneNumber.length <= 15;
    if (!this.validNumber && phoneNumber) {
      this.countryCodeInput.nativeElement.form.control.get('phoneNumber')?.setErrors({ invalid: true });
    } else {
      this.countryCodeInput.nativeElement.form.control.get('phoneNumber')?.setErrors(null);
    }
  }

  resendVerificationMail(): void {
    this.authService.resendVerificationEmail(this.UserSignup.email).subscribe(
      (response) => {
        if (response && response.status === 'OK') {
          this.sweetAlertService.showSuccess('Email Sent', 'Verification Email Sent');
        } else {
          this.sweetAlertService.showError('Error', 'Error Sending Verification Email');
        }
      }
    );
  }

  scrollEvent = (event: any): void => {
    const target = event.target as HTMLElement;
    const isScrollingInsidePanel = this.autoCompletes.some(autoComplete => {
      if (autoComplete.panelOpen) {
        const panel = autoComplete.autocomplete.panel;
        return panel && panel.nativeElement.contains(target);
      }
      return false;
    });
    if (!isScrollingInsidePanel) {
      this.closeAllPanels();
    }
  };

  closeAllPanels() {
    this.autoCompletes.forEach(autoComplete => {
      if (autoComplete.panelOpen) {
        autoComplete.closePanel();
      }
    });
  }

  validateField(field: NgModel, fieldName: string): void {
    if (field.dirty) {
      field.control.markAsTouched();
    }
    const value = field.value?.trim() || '';
    let errors = field.control.errors || {};

    if (!value) {
      errors['required'] = true;
    }

    if (fieldName === 'firstName' || fieldName === 'lastName') {
      const isValid = this.validateName(value.replace(/^Dr\.\s*/, ''));
      const isValidNameLength = this.validateNameLength(value.replace(/^Dr\.\s*/, ''));

      if (value && !isValid) {
        errors['invalidName'] = true;
      } else {
        delete errors['invalidName'];
      }

      if (isValid && !isValidNameLength) {
        errors['invalidNameLength'] = true;
      } else {
        delete errors['invalidNameLength'];
      }
    }

    if (fieldName === 'organization') {
      const isValidPattern = this.validateOrganizationName(value);
      const isValidLength = this.validateOrganizationLength(value);

      if (value && !isValidPattern) {
        errors['invalidOrganization'] = true;
      } else {
        delete errors['invalidOrganization'];
      }

      if (isValidPattern && !isValidLength) {
        errors['invalidOrganizationLength'] = true;
      } else {
        delete errors['invalidOrganizationLength'];
      }
    }

    field.control.setErrors(Object.keys(errors).length ? errors : null);
  }

  validateOrganizationName(name: string): boolean {
    return /^[A-Za-z0-9 ]+$/.test(name);
  }

  validateOrganizationLength(name: string): boolean {
    return name.length <= 150;
  }

  validateNameLength(name: string): boolean {
    const nameLength = name.replace(/^Dr\.\s*/, '').length;
    return nameLength <= 50;
  }
  validateName(value: string): boolean {
    const namePattern = /^[a-zA-Z\s\.]+$/;
    return namePattern.test(value.replace(/^Dr\.\s*/, ''));
  }
  urlInvalid: boolean = false;

  isValidUrl(url: string): boolean {
    const urlPattern = /^(https?:\/\/|www\.)[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}([\/?#].*)?$/;
    return urlPattern.test(url);
  }

  validateUrl(event: any): void {
    const url = event.target.value.trim().toLowerCase();
    event.target.value = url;
    this.urlInvalid = url && !this.isValidUrl(url);
  }

  isPasswordAndConfirmPasswordMatch(password: string, confirmPassword: string): boolean {
    if (password !== '' && confirmPassword !== '') {
      return password === confirmPassword;
    }
    return false;
  }

  updateFirstNamePrefix() {
    if (this.selectedAccountCategory === 'Individual' && this.accountTypeName === 'Doctor') {
      if (!this.UserSignup.firstName?.startsWith('Dr.')) {
        this.UserSignup.firstName = `Dr. ${this.UserSignup.firstName || ''}`.trim();
      }
    } else if (this.UserSignup.firstName?.startsWith('Dr.')) {
      this.UserSignup.firstName = this.UserSignup.firstName.replace(/^Dr\.\s*/, '');
    }
  }
}